export default __webpack_public_path__ + "static/media/lib-4.5bbae36a.webp";